import React from 'react';
import PropTypes from 'prop-types';
import {List} from 'material-ui/List';
import Subheader from 'material-ui/Subheader';
import Divider from 'material-ui/Divider';
import Paper from 'material-ui/Paper';
import Loading from "../../common/Loading/Loading";
import Error from "../../common/Error/Error";
import styles from './ApplicationList.css';
import Application from '../InlineApplication/InlineApplication';
import withTranslation from "../../../hoc/withTranslation";

const ApplicationList = props => {
    const { loading, apps } = props;

    let content;

    if (loading) {
        content = <Loading paper={false} />;
    } else if (apps.length === 0) {
        content =
            <Error
                title={props.t('generic.no_data')}
                subtitle={props.t('account_page.add_some_app')}
            />
    }  else {
        content = apps.map(function(app, index) {
            return <div key={app.id}>
                <Application app={app} />
                {index !== (apps.length - 1) &&  <Divider inset={true}/>}
            </div>
        })
    }

    return (
        <Paper>
            <List>
                <Subheader style={styles.header}>{props.t('generic.application', {count: apps.length})}</Subheader>
                {content}
            </List>
        </Paper>
    );
};

ApplicationList.propTypes = {
    apps: PropTypes.arrayOf(PropTypes.object).isRequired,
    loading: PropTypes.bool.isRequired
};

export default withTranslation(ApplicationList);



// WEBPACK FOOTER //
// src/components/application/ApplicationList/ApplicationList.js